import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvConfigSegment } from '@core/config-models';
import {
  sitecoreItemByIdQuery,
  type ScValue,
  type SitecoreItemByIdResponse,
} from '@core/jss-graphql';
import { map, type Observable } from 'rxjs';

const suiteCrmFormNames: string[] = [
  'inhomeadviesgesprek',
  'bespaarcoach_isolatie',
  'isolatietest_adviesgesprek_website',
  'yellowonline_isolatietest_adviesgesprek_website',
  'ventilatie_aanvraagformulier_website',
  'isolatietest_adviesgesprek',
  'bespaarcoach_zonnepanelen',
  'spaarpanelen',
  'spaarpanelen_mm',
  'zonnepanelen_check',
  'yellowonline_zonnepanelen_check',
  'spaarpanelen_obc',
  'energieplus',
];

export type FormIntegration = {
  formName: string | null;
  useV4Lambda: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class GenericFormSubmitFlowService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(ENVIRONMENT_CONFIG);

  public getFormIntegration(templateId: string): Observable<FormIntegration> {
    const isSme = this.config.segment === EnvConfigSegment.Zakelijk;
    const variables = {
      templateId,
    };
    return this.httpClient
      .post<SitecoreItemByIdResponse>(
        `${isSme ? '/zakelijk' : ''}/graphql`,
        JSON.stringify({
          query: sitecoreItemByIdQuery,
          variables,
        }),
        { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
      )
      .pipe(map((body) => this.mapToFormIntegration(body)));
  }

  public isSuiteCrmForm(form: FormIntegration): boolean {
    const formName = form.formName?.toLowerCase() ?? '';
    return suiteCrmFormNames.includes(formName);
  }

  private mapToFormIntegration(
    body: SitecoreItemByIdResponse
  ): FormIntegration {
    const result: FormIntegration = {
      formName: null,
      useV4Lambda: false,
    };

    const fields = body.data?.item?.fields ?? [];
    for (const field of fields) {
      switch (field.name) {
        case 'FormName': {
          result.formName = (field.jss as ScValue | null)?.value;
          break;
        }
        case 'UseV4Lambda': {
          result.useV4Lambda = (field.jss as ScValue | null)?.value;
          break;
        }
      }
    }

    return result;
  }
}
